import { EXPLORE_SORT } from "enums/new-explore/explore-sort";
import {
  EXPLORE_CERTIFICATE,
  EXPLORE_DURATION,
  EXPLORE_SLUG,
  IExploreInstructorInput,
} from "./explore";
import { EXPLORE_COST } from "enums/new-explore/explore-cost";
import { EXPLORE_PUBLISH_STATUS } from "enums/new-explore/explore-publish-status";
import { EXPLORE_BOUGHT } from "enums/new-explore/explore-bought";
import { COURSE_TYPE } from "./course";
import { STATUS } from "types/common";
import { festival, RequestMeta } from "./common";
import { ApiProductCardImages } from "./product-image";

export const exploreMethodBySlug = {
  [EXPLORE_SLUG.COURSE]: "productSearch",
  [EXPLORE_SLUG.INSTRUCTOR]: "instructorSearch",
  [EXPLORE_SLUG.LANDING]: "landingSearch",
};

export interface NewExplorePayload {
  sku?: string;
  term?: string;
  page: number;
  count: number;
  sort: EXPLORE_SORT;
  category_id?: number;
  cost?: EXPLORE_COST;
  publish_status?: EXPLORE_PUBLISH_STATUS;
  bought?: EXPLORE_BOUGHT;
  type?: COURSE_TYPE;
  duration?: EXPLORE_DURATION;
  instructor_id?: String;
  bypass_exclusion?: number;
  certificate?: EXPLORE_CERTIFICATE;
}

export interface ExplorePagination {
  items_per_page: number;
  page: number;
  remaining_pages: number;
  total_items: number;
  total_pages: number;
}

export interface ExploreSeo {
  description: string;
  keywords: string;
  title: string;
  bread_crumb: string;
}

export interface NewExploreResponse {
  filters?: { [key: string]: NewExploreFilterItem[] };
  pagination: ExplorePagination;
  seo: ExploreSeo;
}

export interface NewExploreCoursesResponse extends NewExploreResponse {
  products: NewExploreProduct[];
}
export interface NewExploreLandingsResponse extends NewExploreResponse {
  landings: NewExploreLanding[];
}

export interface NewExploreInstructorsResponse extends NewExploreResponse {
  instructors: NewExploreInstructor[];
}

export interface NewExploreFilterItem {
  name: string;
  count: number;
  persian_name: string;
  selected: boolean;
  id: string;
}

export interface NewExploreLanding extends ApiProductCardImages {
  slug: string;
  id: number;
  title: string;
  product_count: number;
  url: string;
  total_sales: number;
  total_time_hour: number;
  trend_count: number;
  products: {
    name: string;
    slug: string;
  }[];
  LandingCount?: number;
  subLandingProductCount?: number;
  landingProductHour?: number;
}

export interface NewExploreInstructor {
  id: number;
  full_name: string;
  profile_picture: string;
  url: string;
  slug: string;
  product_count: number;
  student_count: number;
  grade: string | null;
  university: string | null;
  degree: string;
  score: number;
}
export interface NewExploreProduct extends ApiProductCardImages {
  id: number;
  title: string;
  title_short?: string;
  duration: {
    hours: number;
    in_minutes: number;
    minutes: number;
    rounded_in_hour: number;
  };
  url: string;
  sku: string;
  slug: string;
  status: STATUS;
  type: COURSE_TYPE;
  is_huge: boolean;
  has_exam: boolean;
  creation_age: number;
  total_view: number;
  total_sale: number;
  score: number;
  price: number;
  instructors: IExploreInstructorInput[];
  webinar_times: {
    end_at: string;
    updated_at: string;
    product_id: number;
    created_at: string;
    id: number;
    start_at: string;
    url: string;
    capacity: number;
  }[];
  is_favorite: boolean;
  is_buy: boolean;
  in_cart: boolean;
  festival: festival;
  festival_new: festival;
  watchTime_Percent: number;
  has_certificate: boolean;
  total_student: number;
  hasCertificate: boolean;
}

export interface InstructureCourseExploreApi
  extends RequestMeta<
    | NewExploreLandingsResponse
    | NewExploreCoursesResponse
    | NewExploreInstructorsResponse,
    never,
    NewExplorePayload
  > {}

export type CourseExploreApi = (
  params?: NewExplorePayload
) => RequestMeta<NewExploreCoursesResponse, never, NewExplorePayload>;
